var _path, _path2, _path3, _circle, _circle2, _path4, _rect, _rect2, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsEmpty2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.102 37.762A4.762 4.762 0 0 1 59.864 33h70.748a4.762 4.762 0 1 1 0 9.524h-14.966a4.762 4.762 0 1 0 0 9.524h34.694a6.123 6.123 0 0 1 0 12.245H43.537a6.122 6.122 0 1 1 0-12.245H72.79c-.6 0-1.172-.111-1.7-.313a4.764 4.764 0 0 0 0-8.899 4.751 4.751 0 0 1 1.7-.312H59.864a4.762 4.762 0 0 1-4.762-4.762ZM159.184 58.17a6.122 6.122 0 0 1 6.122-6.122h12.245a6.122 6.122 0 0 1 0 12.245h-12.245a6.122 6.122 0 0 1-6.122-6.123ZM43.537 73.816a6.122 6.122 0 1 0 0 12.245h83.674a6.122 6.122 0 0 0 0-12.245H43.537ZM11.565 100.687a5.102 5.102 0 0 1 5.102-5.102h41.496a5.102 5.102 0 0 1 0 10.204h-2.04a5.102 5.102 0 1 0 0 10.204h32.652a5.102 5.102 0 1 1 0-10.204h76.871a5.102 5.102 0 1 1 0 10.204h-13.945a5.102 5.102 0 1 0 0 10.204h7.823a5.102 5.102 0 0 1 0 10.204h-31.293a5.102 5.102 0 0 1 0 10.204H88.095a5.102 5.102 0 0 0 0 10.205h6.123a5.102 5.102 0 1 1 0 10.204H52.04a5.102 5.102 0 0 1 0-10.204h.68a5.103 5.103 0 0 0 0-10.205H9.864a5.102 5.102 0 1 1 0-10.204h20.408a5.102 5.102 0 1 1 0-10.204h1.02a5.102 5.102 0 1 0 0-10.204h-2.38a5.102 5.102 0 1 1 0-10.204H16.667a5.102 5.102 0 0 1-5.102-5.102ZM181.973 105.789a5.102 5.102 0 1 0 0 10.204h12.925a5.102 5.102 0 1 0 0-10.204h-12.925Z",
    fill: "#FBFBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.17 148.646a4.083 4.083 0 0 0 0 8.164h8.844a4.082 4.082 0 0 0 0-8.164h-8.844Z",
    fill: "#FBFBFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.442 124.157a4.082 4.082 0 1 0 0-8.164 4.082 4.082 0 0 0 0 8.164Zm0 1.36a5.442 5.442 0 1 0 .001-10.884 5.442 5.442 0 0 0 0 10.884ZM151.02 42.524a4.081 4.081 0 1 0 .001-8.163 4.081 4.081 0 0 0-.001 8.163Zm0 1.36a5.443 5.443 0 1 0 0-10.885 5.443 5.443 0 0 0 0 10.885Z",
    fill: "#D2D9E7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.721,
    cy: 86.721,
    fill: "#EEF2F5",
    r: 2.721
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.98,
    cy: 145.925,
    fill: "#EEF2F5",
    r: 2.721
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.129 88.102a.68.68 0 0 1 1.361 0v4.082a.68.68 0 0 1-1.361 0v-4.082ZM173.129 95.585a.68.68 0 0 1 1.361 0v4.082a.68.68 0 0 1-1.361 0v-4.082ZM179.592 93.204a.68.68 0 1 1 0 1.36h-4.082a.68.68 0 1 1 0-1.36h4.082ZM172.109 93.204a.68.68 0 1 1 0 1.36h-4.082a.68.68 0 1 1 0-1.36h4.082ZM152.247 83.873a.68.68 0 1 1 .962.962l-2.886 2.886a.68.68 0 0 1-.962-.962l2.886-2.886ZM146.956 89.164a.68.68 0 0 1 .962.962l-2.886 2.886a.68.68 0 1 1-.962-.962l2.886-2.886ZM153.209 92.05a.68.68 0 1 1-.962.962l-2.886-2.886a.68.68 0 1 1 .962-.962l2.886 2.886ZM147.918 86.759a.68.68 0 1 1-.962.962l-2.886-2.886a.68.68 0 1 1 .962-.962l2.886 2.886ZM49.2 45.956a1.289 1.289 0 1 1 0 2.578h-7.733a1.289 1.289 0 1 1 0-2.578h7.734ZM35.023 45.956a1.289 1.289 0 1 1 0 2.578h-7.734a1.289 1.289 0 1 1 0-2.578h7.733ZM39.534 58.2a1.289 1.289 0 0 1-2.578 0v-7.733a1.289 1.289 0 0 1 2.578 0v7.734ZM39.534 44.023a1.289 1.289 0 0 1-2.578 0v-7.734a1.289 1.289 0 1 1 2.578 0v7.734Z",
    fill: "#D2D9E7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 93.003,
    y: 52.047,
    width: 13.994,
    height: 18.659,
    rx: 6.997,
    fill: "#DDE2EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 87.561,
    y: 117.354,
    width: 24.878,
    height: 29.543,
    rx: 12.439,
    fill: "url(#a)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.788 89.555c0-16.85-13.66-30.51-30.51-30.51h-2.44c-16.85 0-30.51 13.66-30.51 30.51v26.556a3.955 3.955 0 0 1-3.955 3.955h-.326a7.585 7.585 0 0 0 0 15.169h71.906a7.585 7.585 0 0 0 0-15.169h-.248a3.917 3.917 0 0 1-3.917-3.917V89.555Z",
    fill: "url(#b)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100 85.517c-4.591 0-7.885 4.426-6.565 8.823l2.996 9.988.025.085c.109.362.211.706.38 1.005a3.066 3.066 0 0 0 2.004 1.491c.335.075.693.075 1.072.074h.176c.379.001.737.001 1.072-.074a3.066 3.066 0 0 0 2.005-1.491c.168-.299.27-.643.379-1.005l.025-.085 2.996-9.988c1.319-4.397-1.974-8.823-6.565-8.823ZM100 110.434a4.983 4.983 0 1 0 0 9.966 4.983 4.983 0 0 0 0-9.966Z",
    fill: "#FBFBFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 99,
    y1: 129,
    x2: 100,
    y2: 146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D8DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEDF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 112,
    y1: 58,
    x2: 67,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E6EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F3F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsEmpty2);
export default __webpack_public_path__ + "static/media/notifications_empty-2.7b8108eaf2d0247a89857255d64dee72.svg";
export { ForwardRef as ReactComponent };